export default __webpack_public_path__ + "static/media/640_business03-fr-mobile.4a36c470.png";